import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

type TParams = {
  Page?: number;
  PageSize?: number;
  onboardingStatus?: string;
  SubsequentOnboardingStatus?: string;
  customerId?: string;
  StartDate?: string;
  EndDate?: string;
};

const getAggregatorOnboardingStatus = async ({
  Page,
  PageSize,
  onboardingStatus,
  SubsequentOnboardingStatus,
  customerId,
  StartDate,
  EndDate,
}: TParams) => {
  let queryParams = `?Page=${Page}&PageSize=${PageSize}`;

  if (onboardingStatus) {
    queryParams = `${queryParams}&${onboardingStatus}`;
  }

  if (SubsequentOnboardingStatus) {
    queryParams = `${queryParams}&${SubsequentOnboardingStatus}`;
  }
  if (customerId) {
    queryParams = `${queryParams}&customerId=${customerId}`;
  }

  if (StartDate && EndDate) {
    queryParams = `${queryParams}&StartDate=${StartDate}&EndDate=${EndDate}`;
  }

  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.GET_AGGREGATOR_ONBOARDING_STATUS}${queryParams}`
  );

  return data;
};

export default function useAggregatorOnboardingStatus({
  Page,
  PageSize,
  onboardingStatus,
  SubsequentOnboardingStatus,
  customerId,
  StartDate,
  EndDate,
}: TParams) {
  return useQuery(
    [
      {
        Page,
        PageSize,
        onboardingStatus,
        SubsequentOnboardingStatus,
        customerId,
        StartDate,
        EndDate,
      },
      "getAggregatorOnboardingStatus",
    ],
    getAggregatorOnboardingStatus
  );
}
